import { Link } from "react-router-dom";
import { HomeIcon, Briefcase, CheckCircle2, ArrowRight } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function Pillar({ kind }) {
  const isSettle = kind === "settle";
  useSEO({
    title: isSettle ? "Je m'établis au Canada" : "J'entreprends au Canada",
    description: isSettle
      ? "Démarches administratives, logement, banque, école, santé, auto-école : tout pour bien démarrer votre nouvelle vie au Canada."
      : "Accompagnement, financement, marketing, réseautage : lancez ou développez votre entreprise au Canada avec DemkaBiz.",
  });
  const data = isSettle
    ? {
        title: "Je m'établis",
        accent: "Bienvenue au Canada",
        intro: "Avant votre arrivée et tout au long de votre établissement, DemkaBiz met à votre disposition un écosystème de services adaptés à votre réalité pour que chaque étape de votre nouvelle vie se passe dans les meilleures conditions.",
        image: "https://images.unsplash.com/photo-1758523671893-0ba21cf4260f?w=1200",
        steps: [
          "Services de pré-départ : préparation avant même votre arrivée",
          "Démarches administratives (NAS, RAMQ, permis, immigration…)",
          "Logement : location, déménagement, aménagement",
          "Banque, assurances et premiers crédits",
          "École, garderie et services pour la famille",
          "Auto-école et accompagnement permis de conduire",
          "Santé et bien-être en français",
          "Guide pratique « Où aller. Quoi faire. En communauté. » (téléchargeable)",
        ],
        cta: "Trouver un service",
        ctaLink: "/je-cherche-un-service",
      }
    : {
        title: "J'entreprends",
        accent: "Lancez votre projet au Canada",
        intro: "Un parcours entrepreneurial accompagné, du premier business plan au lancement, en passant par le financement et le marketing.",
        image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200",
        steps: [
          "Conseils juridiques et fiscaux pour immigrés",
          "Accompagnement à la création d'entreprise",
          "Programmes de financement et subventions",
          "Marketing, branding et présence en ligne",
          "Réseautage et événements communautaires",
          "Accès aux marchés Canada-Afrique",
        ],
        cta: "Devenir entrepreneur partenaire",
        ctaLink: "/inscription?role=entrepreneur",
      };

  const Icon = isSettle ? HomeIcon : Briefcase;

  return (
    <div data-testid={`pillar-${kind}-page`}>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">{data.accent}</p>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-foreground tracking-tight leading-[1.05]">{data.title}</h1>
          <p className="text-muted-foreground mt-5 max-w-xl leading-relaxed">{data.intro}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to={data.ctaLink} className="btn-primary">{data.cta} <ArrowRight className="w-4 h-4" /></Link>
            <Link to="/contact" className="btn-outline">Parler à un conseiller</Link>
          </div>
        </div>
        <div className="relative">
          <img src={data.image} alt={data.title} className="w-full aspect-[4/3] object-cover rounded-3xl" />
          <div className="absolute -bottom-6 -left-6 card-surface p-4 max-w-[200px] hidden sm:block">
            <Icon className="w-6 h-6 text-primary mb-2" />
            <p className="text-sm font-display font-semibold">{isSettle ? "Accompagnement de A à Z" : "De l'idée au lancement"}</p>
          </div>
        </div>
      </section>

      <section className="bg-secondary/50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl sm:text-4xl tracking-tight mb-10">Ce que vous trouverez</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {data.steps.map((s, i) => (
              <div key={i} className="card-surface p-6 flex items-start gap-3">
                <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <p className="text-sm text-foreground/90 leading-relaxed">{s}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
